/* tslint:disable */
/* eslint-disable */
/**
 * My API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface FieldInfo
 */
export interface FieldInfo {
    /**
     * 
     * @type {string}
     * @memberof FieldInfo
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof FieldInfo
     */
    'dataType'?: FieldInfoDataTypeEnum;
    /**
     * 
     * @type {boolean}
     * @memberof FieldInfo
     */
    'required'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FieldInfo
     */
    'encrypted'?: boolean;
}

export const FieldInfoDataTypeEnum = {
    Long: 'LONG',
    Float: 'FLOAT',
    String: 'STRING',
    Timestamp: 'TIMESTAMP',
    Boolean: 'BOOLEAN',
    Any: 'ANY',
    Double: 'DOUBLE',
    Unrecognized: 'UNRECOGNIZED'
} as const;

export type FieldInfoDataTypeEnum = typeof FieldInfoDataTypeEnum[keyof typeof FieldInfoDataTypeEnum];


